import React from 'react'
import { SVGProps } from 'react'

const MapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.00016 0C4.805 0 2.20557 2.59944 2.20557 5.79456C2.20557 9.75981 7.39116 15.581 7.61194 15.8269C7.81932 16.0579 8.18138 16.0575 8.38838 15.8269C8.60916 15.581 13.7948 9.75981 13.7948 5.79456C13.7947 2.59944 11.1953 0 8.00016 0ZM8.00016 8.70997C6.3926 8.70997 5.08478 7.40212 5.08478 5.79456C5.08478 4.187 6.39263 2.87919 8.00016 2.87919C9.60769 2.87919 10.9155 4.18703 10.9155 5.79459C10.9155 7.40216 9.60769 8.70997 8.00016 8.70997Z" />
  </svg>
)
export default MapIcon
